import React, { useState } from 'react';
import { ClipboardListIcon, FootprintsIcon, MoveDiagonalIcon, Rows3Icon, ScaleIcon, ZapIcon } from './icons';
import { Pill } from './Pill';
import { volumes } from '../data/volumes';
const icons = [FootprintsIcon, Rows3Icon, ScaleIcon, MoveDiagonalIcon, ZapIcon, ClipboardListIcon];
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="volumes-heading" id="volumes" data-id="element-215" data-mp="3g5r8v23srxfd">
      <div className="mx-auto max-w-3xl px-6" data-id="element-216" data-mp="3c1t9cqak8kls">
        <div className="text-center" data-id="element-217" data-mp="3pw2q1qchs347">
          <Pill data-id="element-218" data-mp="3px41vx1c0tmz">The library</Pill>
          <h2 id="volumes-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-219" data-mp="3l4kob02n9yi6">
            6 Complete Master Volumes
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-sans text-sm leading-relaxed text-ash" data-id="element-220" data-mp="2sg6qolfgx475">
            Tap any volume to see what’s inside.
          </p>
        </div>

        <ol className="mt-9 space-y-3" data-id="element-221" data-mp="29do2g3vrlmct">
          {volumes.map((volume, index) => {
          const Icon = icons[index];
          const isOpen = openIndex === index;
          return <li key={volume.number} data-id="element-222" data-mp="2j7elgt94h4l4" data-mpi={index}>
                <div className={`rounded-2xl border transition-colors duration-150 ease-out ${isOpen ? 'border-gold/60 bg-blush' : 'border-rose-deep/25 bg-white hover:border-rose-deep/60'}`} data-id="element-223" data-mp="2o4wltv92qbhi">
                  <h3 data-id="element-224" data-mp="20dr7xlmp1t9u">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-start gap-4 rounded-2xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wine" data-id="element-225" data-mp="20d94o51m6esf">
                      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-wine text-cream' : 'bg-rose-light text-wine'}`} aria-hidden="true" data-id="element-226" data-mp="1bsj08gfqerb7">
                        <Icon className="h-4 w-4" strokeWidth={1.7} data-id="element-227" data-mp="t29qmlhm7x9h" />
                      </span>
                      <span className="min-w-0" data-id="element-228" data-mp="16tokjnd29ivb">
                        <span className="block font-display text-xl leading-snug text-charcoal" data-id="element-229" data-mp="16uhko5hila4h">
                          <span className="text-wine" data-id="element-230" data-mp="1203klprwqeth">
                            V{Number(volume.number)}.
                          </span>{' '}
                          {volume.title}
                        </span>
                        <span className="mt-1 block font-sans text-[0.85rem] leading-relaxed text-ash" data-id="element-231" data-mp="2l0up5u3xi4tg">
                          {volume.summary}
                        </span>
                      </span>
                    </button>
                  </h3>

                  <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-232" data-mp="2c1hbep8ruu2x">
                    <div className="overflow-hidden" data-id="element-233" data-mp="2uqxixwivjmsu">
                      <ul className="grid gap-x-8 gap-y-2 border-t border-gold/30 px-5 py-4 sm:grid-cols-2" data-id="element-234" data-mp="2usi979y5ojkw">
                        {volume.contents.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.85rem] leading-relaxed text-charcoal/80" data-id="element-235" data-mp="1jah9qkxwy2ef">
                            <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-goldink" aria-hidden="true" data-id="element-236" data-mp="23ljopt2ncffn" />
                            {item}
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}